import { Check, X } from 'lucide-react';

export const getPasswordCriteria = (password: string) => {
  return {
    minLength: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
  };
};

const CRITERIA_LABELS: [keyof ReturnType<typeof getPasswordCriteria>, string][] = [
  ['minLength', 'At least 8 characters'],
  ['uppercase', 'One uppercase letter'],
  ['lowercase', 'One lowercase letter'],
  ['number', 'One number'],
  ['special', 'One special character'],
];

export const PasswordCriteriaList = ({ password }: { password: string }) => {
  if (!password.length) return null;

  const criteria = getPasswordCriteria(password);

  return (
    <ul className="space-y-1 rounded-xl border border-slate-100 bg-slate-50 p-3 text-xs">
      {CRITERIA_LABELS.map(([key, label]) => {
        const met = criteria[key];
        return (
          <li
            key={key}
            className={`flex items-center gap-2 ${met ? 'text-green-600' : 'text-slate-400'}`}
          >
            {met ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />}
            {label}
          </li>
        );
      })}
    </ul>
  );
};
